module.exports = __webpack_public_path__ + "static/img/3_2.1e2cea2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/3_2.png
// module id = 5F1j
// module chunks = 2